export const toText = (enumString) => {
  if (typeof enumString !== "string") {
    return "";
  }
  return enumString?.replace(/([a-z])([A-Z])/g, "$1 $2");
};
